module.exports = __webpack_public_path__ + "img/icon-chinese.253fdbf8.svg";